module.exports = __webpack_public_path__ + "img/home-rule.b4d365d9.png";